import React from "react";
import { Route, Routes } from "react-router-dom";

import CgmExportGraphDevPage from "./CgmExportGraphDevPage";

const DevRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/cgm-export-graph" element={<CgmExportGraphDevPage />} />
    </Routes>
  );
};

export default DevRoutes;
